import { FRONTEND_VIEW_ENTRIES, FRONTEND_VIEWS_BY_KEYS } from "src/components/views/frontendViews/frontendViewsList.ts";

export const isImplementedFrontendViewId = (viewId: string): boolean => {
	return FRONTEND_VIEWS_BY_KEYS[viewId] !== undefined;
};

export const getFrontendViewKeyByUrl = (path: string): string | undefined => {
	const match = FRONTEND_VIEW_ENTRIES.find(([, value]) => {
		return value.url === path;
	});
	if (match === undefined) {
		return undefined;
	}
	return match[0];
};

